


import { doc,  collection, getDocs, getDoc } from "firebase/firestore";
import { setupFireStore } from "../../../firebase/firebase.config";
import { FormType } from "../../common/types/question";
import { SiteObject } from "../../common/types/site";

const { Firestore: db } = setupFireStore()

export class ReporterService {

    async getAllForms(): Promise<FormType[]> {

        let response: FormType[] = [];
        const result = collection(db, "sections");
        const data = await getDocs(result);
        data.docs.forEach((item) => {
            response = [...response, item.data() as FormType];
        });

        return response || [];
    }

    async getSite(Id: string): Promise<SiteObject> {
        const response = doc(db, "sites", Id);
        const data = await getDoc(response);
        return data.data() as SiteObject;
    };

    async getSites(): Promise<SiteObject[]> {
        let results: any = [];
        const response = collection(db, "sites");
        const data = await getDocs(response);
        data.docs.forEach((item) => {
            results = [...results, item.data()];
        });

        return results;
    };

}